
import { Inject, Injectable, DOCUMENT } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ThemeManagerService {
  themeChange: BehaviorSubject<string> = new BehaviorSubject<string>(null);

  constructor(
    @Inject(DOCUMENT) private document: Document) { }

  setTheme(theme: string) {
    this.themeChange.next(theme);
    if (theme == 'dark') {
      this.document.body.classList.add('dark-theme');
    } else {
      this.document.body.classList.remove('dark-theme');
    }
    // this.styleManager.setStyle('theme', `assets/theme/${theme}.css`);
  }
}
